// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__XNcWL","amount":"Amount_amount__1E1pk","tip":"Amount_tip__4MlRr","tipHeader":"Amount_tipHeader__1KCYd","tipsWrap":"Amount_tipsWrap__30Ad8"};